import { Attachment } from '../../../types';
import { FileUploadState } from './FileManager';
import { getFileType, isImageFile } from './fileUtils';

export const convertAttachmentsToFileUploadState = (
  attachments: Attachment[]
): FileUploadState[] => {
  return attachments.map((attachment, index) => {
    const fileName =
      attachment.original_filename || attachment.fileName || 'unknown';
    const previewUrl =
      attachment.preview_url || attachment.previewUrl || attachment.preview;
    const fileType = getFileType(fileName);

    return {
      id: attachment.attachment_id || `existing_${index}`,
      file: new File([], fileName, { type: fileType }),
      status: 'completed' as const,
      progress: 100,
      attachmentId: attachment.attachment_id,
      previewUrl: previewUrl,
      preview: isImageFile(fileType) ? previewUrl : undefined,
    };
  });
};

export const createAttachmentObject = (file: FileUploadState) => ({
  attachment_id: file.attachmentId!,
  preview_url: file.previewUrl!,
  original_filename: file.file.name,
});

export const updateQuestionAttachmentsIfNeeded = (
  currentStepKey: string,
  questionId: string | undefined,
  allFiles: FileUploadState[],
  updateQuestionAttachments: (questionId: string, attachments: any[]) => void,
  excludeFileId?: string
) => {
  if (currentStepKey !== 'sources' || !questionId) return;

  const completedFiles = allFiles.filter(
    f => f.status === 'completed' && f.attachmentId && f.id !== excludeFileId
  );

  const attachments = completedFiles.map(createAttachmentObject);
  console.log('Updating attachments:', attachments);
  updateQuestionAttachments(questionId, attachments);
};

export const extractUploadedFilenames = (
  files: FileUploadState[]
): string[] => {
  return files
    .filter(f => f.status === 'completed' && f.file?.name)
    .map(f => f.file.name);
};

export const updateQuestionUploadedFilenamesIfNeeded = (
  questionId: string | undefined,
  allFiles: FileUploadState[],
  updateQuestionUploadedFilenames: (
    questionId: string,
    uploadedFilenames: string[]
  ) => void
) => {
  if (!questionId) return;

  const uploadedFilenames = extractUploadedFilenames(allFiles);
  console.log(
    'Updating uploaded filenames for question:',
    questionId,
    uploadedFilenames
  );
  updateQuestionUploadedFilenames(questionId, uploadedFilenames);
};
